import { Box, Fieldset } from '@chakra-ui/react';
import { FormField } from '@ui/components/FormField';
import { type FC } from 'react';

import { useCreateAgentModal } from '../useCreateAgentModal';
import Subtitle from './Subtitle';

const CreateAgentExtraInfo: FC = () => {
  const step = useCreateAgentModal((s) => s.step);

  return (
    <Box hidden={step !== 'ExtraInfo'}>
      <Subtitle mb={6}>
        Add social links for their fanbase (˘◡˘)♡ (Optional)
      </Subtitle>
      <Fieldset.Root display="flex" flexDir="column" gap={4}>
        <Fieldset.Content>
          <FormField name="twitter" label="Twitter" placeholder="X handle" />
          <FormField
            name="telegram"
            label="Telegram"
            placeholder="Telegram handle"
          />
          <FormField
            name="youtube"
            label="YouTube"
            placeholder="YouTube handle"
          />
          <FormField
            validators={{
              pattern: {
                value:
                  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                message: 'Invalid URL',
              },
            }}
            name="website"
            label="Website"
            placeholder="Website"
          />
        </Fieldset.Content>
      </Fieldset.Root>
    </Box>
  );
};

export default CreateAgentExtraInfo;
